"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactOverlays = require("react-overlays");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _DropdownToggle = _interopRequireDefault(require("../Filters/DropdownToggle"));

var _DropdownOptions = _interopRequireDefault(require("../Filters/DropdownOptions"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint object-curly-newline: ["error", { "ObjectExpression": "always" }] */
// Components
const StyledListItem = _styledComponents.default.li.withConfig({
  displayName: "NavDropdown__StyledListItem",
  componentId: "design-system__sc-10s2yy2-0"
})(["flex:0 0 auto;color:#fff;height:4.5rem;& span > div:not(.icon-label) path{fill:white;}", " &:hover{background:#f9f9f9;& span > div:not(.icon-label) path{fill:black;}}"], _ref => {
  let {
    isOpen
  } = _ref;
  return isOpen && (0, _styledComponents.css)(["background:#f9f9f9;& span > div:not(.icon-label) path{fill:black;}"]);
});

const StyledSpan = _styledComponents.default.span.withConfig({
  displayName: "NavDropdown__StyledSpan",
  componentId: "design-system__sc-10s2yy2-1"
})(["font-family:", ";font-size:", ";color:", ";text-transform:uppercase;cursor:pointer;text-decoration:none;display:flex;height:4.5rem;user-select:none;& .icon-label{margin-top:0.25rem;}& > div{margin-left:0.5rem;}"], _BaseTheme.default.type.family.system, _BaseTheme.default.type.size.normal, _BaseTheme.default.colors.black);

const NavDropdown = _ref2 => {
  let {
    drop,
    alignEnd,
    title,
    pages,
    icon
  } = _ref2;
  const [isOpen, setOpen] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(StyledListItem, {
    isOpen: isOpen
  }, /*#__PURE__*/_react.default.createElement(_reactOverlays.Dropdown, {
    show: isOpen,
    onToggle: nextShow => setOpen(nextShow),
    drop: drop,
    alignEnd: alignEnd,
    itemSelector: "button:not(:disabled)"
  }, () => /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DropdownToggle.default, {
    isOpen: isOpen
  }, /*#__PURE__*/_react.default.createElement(StyledSpan, null, icon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "icon-label",
    type: icon,
    align: "center",
    size: "24"
  }) : title, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "arrow",
    size: "12"
  }))), pages.length > 0 && /*#__PURE__*/_react.default.createElement(_DropdownOptions.default, {
    clickCallback: () => setOpen(false),
    pages: pages
  }))));
};

NavDropdown.propTypes = {
  title: _propTypes.default.string.isRequired,
  icon: _propTypes.default.string,
  drop: _propTypes.default.string,
  alignEnd: _propTypes.default.bool,
  pages: _propTypes.default.arrayOf(_propTypes.default.object)
};
NavDropdown.defaultProps = {
  drop: 'down',
  icon: undefined,
  alignEnd: false,
  pages: []
};
var _default = NavDropdown;
exports.default = _default;